import { render, staticRenderFns } from "./secondRank.vue?vue&type=template&id=286b6e19&scoped=true&"
import script from "./secondRank.vue?vue&type=script&lang=js&"
export * from "./secondRank.vue?vue&type=script&lang=js&"
import style0 from "./secondRank.vue?vue&type=style&index=0&id=286b6e19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286b6e19",
  null
  
)

export default component.exports